import { css, cva } from '@/styled-system/css';

export const comboboxContentRecipe = cva({
  base: {
    borderRadius: 'obj.soft',
    backgroundColor: 'bg.elevated.mediumShadow',
    boxShadow: 'md',
    position: 'relative',
    overflow: 'auto',
    maxHeight: '360px',
  },
  variants: {
    dividers: {
      true: {
        '& .c11n_combobox__group:not(:last-child)': {
          borderBottomWidth: 'default',
          borderBottomStyle: 'solid',
          borderBottomColor: 'Combobox.Group.border',
        },
      },
      false: {},
    },
  },
});

export const comboboxContentPositionerStyles = css.raw({
  zIndex: 'combobox',
});
